const DEFAULT_POSTHOG_PROJECT_KEY = 'phc_uN4hu2XEgRnc9J3bhoy3zHXhzKLFfApMb4pr4N6e47Us'
const DEFAULT_POSTHOG_HOST = 'https://t.parnasamatch.com'
const DEFAULT_POSTHOG_UI_HOST = 'https://us.posthog.com'
const DIRECT_POSTHOG_INGEST_HOSTS = new Set([
  'https://us.i.posthog.com',
  'https://eu.i.posthog.com',
  'https://app.posthog.com',
])
const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production'
const BROWSER_POSTHOG_KEY = String(
  process.env.NEXT_PUBLIC_POSTHOG_KEY ||
  process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN ||
  DEFAULT_POSTHOG_PROJECT_KEY
).trim()
const BROWSER_POSTHOG_HOST = normalizePostHogIngestHost(process.env.NEXT_PUBLIC_POSTHOG_HOST)
const BROWSER_POSTHOG_DEV_ENABLED = process.env.NEXT_PUBLIC_ENABLE_POSTHOG_DEV === 'true'

const INVALID_POSTHOG_KEY_VALUES = new Set([
  '',
  'personal_api_key',
  'posthog_personal_api_key',
  'your_posthog_key',
  'your-project-api-key',
  'changeme',
])

export function shouldEnablePostHog(env = process.env) {
  return IS_PRODUCTION_BUILD || env.NODE_ENV === 'production' || env.NEXT_PUBLIC_ENABLE_POSTHOG_DEV === 'true'
}

function normalizePostHogIngestHost(value) {
  const host = String(value || '').trim().replace(/\/$/, '')
  if (!host || DIRECT_POSTHOG_INGEST_HOSTS.has(host)) return DEFAULT_POSTHOG_HOST
  return host
}

export function isValidPostHogKey(value) {
  const key = String(value || '').trim()
  if (!key) return false
  if (INVALID_POSTHOG_KEY_VALUES.has(key.toLowerCase())) return false
  if (/\s/.test(key)) return false

  return (
    key.startsWith('phc_') ||
    key.startsWith('phx_') ||
    /^[A-Za-z0-9_-]{20,}$/.test(key)
  )
}

export function getPostHogRuntimeConfig(env = process.env) {
  const isDefaultRuntimeEnv = env === process.env
  const key = isDefaultRuntimeEnv
    ? BROWSER_POSTHOG_KEY
    : String(env.NEXT_PUBLIC_POSTHOG_KEY || env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN || DEFAULT_POSTHOG_PROJECT_KEY).trim()
  const host = isDefaultRuntimeEnv
    ? BROWSER_POSTHOG_HOST
    : normalizePostHogIngestHost(env.NEXT_PUBLIC_POSTHOG_HOST)
  const enabled = isDefaultRuntimeEnv
    ? (IS_PRODUCTION_BUILD || BROWSER_POSTHOG_DEV_ENABLED) && isValidPostHogKey(key)
    : shouldEnablePostHog(env) && isValidPostHogKey(key)

  return {
    enabled,
    key,
    host,
    uiHost: DEFAULT_POSTHOG_UI_HOST,
  }
}

export function getPostHogServerConfig(env = process.env) {
  const key = String(
    env.POSTHOG_PROJECT_API_KEY ||
      env.POSTHOG_API_KEY ||
      env.NEXT_PUBLIC_POSTHOG_KEY ||
      env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN ||
      DEFAULT_POSTHOG_PROJECT_KEY
  ).trim()
  const host = normalizePostHogIngestHost(env.POSTHOG_HOST || env.NEXT_PUBLIC_POSTHOG_HOST)

  return {
    enabled: shouldEnablePostHog(env) && isValidPostHogKey(key),
    key,
    host,
    uiHost: DEFAULT_POSTHOG_UI_HOST,
  }
}

export { DEFAULT_POSTHOG_HOST, DEFAULT_POSTHOG_PROJECT_KEY, DEFAULT_POSTHOG_UI_HOST }
